<div class="pos-chart">

  <div #pos_chartdiv [id]="'pos-chart__chart_' + country.label"></div>

</div>

